import { render, staticRenderFns } from "./DamageAssessorCaseOverview.vue?vue&type=template&id=6c8eb1c6&scoped=true"
import script from "./DamageAssessorCaseOverview.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8eb1c6",
  null
  
)

export default component.exports